import { createFileRoute, Navigate } from "@tanstack/react-router";

import {
  canonicalSettingsSection,
  settingsPanelForSection,
} from "../components/settings/settingsSections";

function OrgSettingsSectionRoute() {
  const { org, section } = Route.useParams();
  const moved = canonicalSettingsSection(section);
  if (moved) {
    return <Navigate to="/$org/settings/$section" params={{ org, section: moved }} replace />;
  }
  const Panel = settingsPanelForSection(section);
  if (!Panel) {
    return (
      <Navigate to="/$org/settings/$section" params={{ org, section: "general" }} replace />
    );
  }
  return <Panel />;
}

export const Route = createFileRoute("/$org/settings/$section")({
  component: OrgSettingsSectionRoute,
});
